<template>
	<div class="relative !px-4 !py-16 flex flex-col gap-4 items-center !container mx-auto !max-w-seint">
		<h1 class="!m-0 !p-0 font-butler-light text-3xl/[38px] font-light text-center">
			Select the level that best matches your skin tone
		</h1>
		<ul class="!m-0 !p-0 flex flex-col gap-6 md:grid md:grid-cols-2">
			<li v-for="(value, key) in levels" :key="key" class="flex flex-col gap-2">
				<h4 class="text-sm">{{ key }}</h4>
				<button
					type="button"
					:aria-label="`Select Level ${value.level}`"
					@click="() => handleNextStep(value.level, key)"
					:class="[
						'grid grid-cols-4 gap-0.5 hover:ring-2 hover:ring-black',
						isActiveLevel(value.level) ? 'ring-2 ring-black' : '',
					]"
				>
					<img v-for="{ src, alt } in value.images" :src="src" :alt="alt" :key="alt" />
				</button>
			</li>
		</ul>
	</div>
</template>
<script setup>
import { onMounted } from 'vue'

const props = defineProps({
	levels: {
		type: Object,
		required: true,
	},
	isActiveLevel: {
		type: Function,
		required: true,
	},
	setLevelId: {
		type: Function,
		required: true,
	},
	setLevelName: {
		type: Function,
		required: true,
	},
	setStep: {
		type: Function,
		required: true,
	},
})

onMounted(() => {
	window.scrollTo(0, 0)
})

const handleNextStep = (selectionId, selectionName) => {
	props.setLevelId(selectionId)
	props.setLevelName(selectionName)
	props.setStep(2)
}
</script>
